<template>
  <div class="home-page">
    <!-- 头部 -->
    <PageNav></PageNav>
    <div style="width: 100%;height: 80px;"></div>
    <!-- banner -->
    <section class="hero">
      <img src="@/assets/banner.jpg" alt="" class="hero-bg"/>
      <div class="hero-mask">
        <div class="container">
          <div class="hero-content">
            <h2>赋能软件创新<br>共筑数字昆山</h2>
            <p>昆山市软件行业协会致力于连接政府与企业，推动本地软件产业高质量发展。</p>
            <div class="btns">
              <a @click="goToAbout" style="cursor: pointer;" class="btn-primary">加入协会</a>
              <a @click="goToServices" style="cursor: pointer;" class="btn-outline">办理业务</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 快捷服务 -->
    <section class="quick-service">
      <div class="container">
        <div class="service-grid">
          <div @click="goToSoft" style="cursor: pointer;" class="service-item">
            <div class="icon-box">
              <iconify-icon icon="mdi:certificate" width="32" height="32"></iconify-icon>
            </div>
            <span>双软评估</span>
          </div>
          <div @click="goToCopyright" style="cursor: pointer;" class="service-item">
            <div class="icon-box">
              <iconify-icon icon="mdi:shield-check" width="32" height="32"></iconify-icon>
            </div>
            <span>软件著作权</span>
          </div>
          <div @click="goToTest" style="cursor: pointer;" class="service-item">
            <div class="icon-box">
              <iconify-icon icon="mdi:file-search" width="32" height="32"></iconify-icon>
            </div>
            <span>产品登记测试</span>
          </div>
          <div @click="goToEvaluate" style="cursor: pointer;" class="service-item">
            <div class="icon-box">
              <iconify-icon icon="mdi:account-group" width="32" height="32"></iconify-icon>
            </div>
            <span>交付能力评估</span>
          </div>
          <div @click="goToStat" style="cursor: pointer;" class="service-item">
            <div class="icon-box">
              <iconify-icon icon="mdi:chart-line" width="32" height="32"></iconify-icon>
            </div>
            <span>信用评价</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻 -->
    <section class="news-policy-section">
      <div class="container">
        <div class="grid-wrapper">
          <!-- 左侧：行业资讯 -->
          <div class="news-left">
            <div class="section-head">
              <h3 class="section-title">
                <iconify-icon icon="mdi:newspaper" width="24" height="24"></iconify-icon>
                行业资讯
              </h3>
              <a @click="goToNews" style="cursor: pointer;" class="more-btn">更多 +</a>
            </div>
            <div class="news-list">
              <div class="news-item" v-for="(item,index) in richList" :key="index" @click="goToDetail(item)">
                <div class="pic">
                  <img :src="item.imgUrl" alt="" />
                </div>
                <div class="text-box">
                  <h4>{{item.title}}</h4>
                  <p class="desc">{{item.textContent}}</p>
                  <span class="date">{{item.releaseTime ? item.releaseTime.substring(0, 10) : item.createTime ? item.createTime.substring(0, 10) : ' ' }}</span>
                </div>
              </div>

<!--              <div class="news-item">
                <div class="pic">
                  <img src="https://picsum.photos/300/200" alt="" />
                </div>
                <div class="text-box">
                  <h4>关于举办“2026 软件开发者大会·昆山峰会”的通知</h4>
                  <p class="desc">诚邀广大软件从业者参与本次技术盛会，共同探讨大模型在垂直领域的落地应用...</p>
                  <span class="date">2026-04-20</span>
                </div>
              </div>-->
            </div>
          </div>

          <!-- 右侧：政策法规 -->
          <div class="policy-right">
            <div class="section-head">
              <h3 class="section-title">
                <iconify-icon icon="mdi:bullhorn" width="24" height="24" class="policy-icon"></iconify-icon>
                政策法规
              </h3>
              <a @click="goToPolicy" style="cursor: pointer;" class="more-btn">更多 +</a>
            </div>
            <ul class="policy-list">
              <li v-for="(item, index) in richList2" :key="index" @click="goToDetail2(item)">
                <span class="dot"></span>
                <span class="text">{{item.title}}</span>
              </li>
<!--              <li>
                <span class="dot"></span>
                <span class="text">昆山市关于进一步优化软件企业营商环境的实施办法</span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">2026 年第一批次软件企业评估公示名单</span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">关于开展“软考”考前公益辅导讲座的通知</span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">关于组织开展软件企业信用评价工作的通知</span>
              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据统计区块 -->
    <section class="data-count">
      <!-- 背景装饰图标 -->
      <iconify-icon class="data-icon cloud" icon="mdi:cloud"></iconify-icon>
      <iconify-icon class="data-icon network" icon="mdi:connection"></iconify-icon>

      <!-- 数据内容（居中且均匀分布） -->
      <div class="container">
        <div class="data-grid">
          <div class="data-item">
            <div class="num">52+</div>
            <div class="label">正式会员单位</div>
          </div>
          <div class="data-item">
            <div class="num">15年</div>
            <div class="label">专业服务历程</div>
          </div>
          <div class="data-item">
            <div class="num">2000+</div>
            <div class="label">软著办理案例</div>
          </div>
          <div class="data-item">
            <div class="num">5场</div>
            <div class="label">年度行业活动</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心会员企业展示 -->
    <section class="member-section">
      <div class="container">
        <!-- 标题：居中显示 -->
        <div class="section-header">
          <h2 class="section-title">核心会员企业展示</h2>
          <div class="divider"></div>
        </div>

        <!-- 企业logo轮播 -->
        <div class="logo-carousel">
          <div class="logo-track">
            <!-- @click="goTo(item)" -->
            <div class="logo-item" v-for="(item, index) in displayMemberList"  :key="`${item.id || item.companyName || 'member'}-${index}`">
             <a :href="item.website" target="_blank">
               <img :src="getMemberLogo(item)" alt="企业logo">
             </a>
            </div>
          </div>
        </div>

        <!-- 查看全部链接 -->
        <div class="view-all">
          <a @click="goToMembers" style="cursor: pointer;" class="view-all-link">查看全部会员单位 →</a>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <PageFooter></PageFooter>
  </div>
</template>

<script>
import PageNav from '@/components/PageNav'
import PageFooter from "@/components/PageFooter.vue";
import {getMemberListApi, getRichtextListApi} from "@/api/api";

export default {
  name: "Index",
  components: {PageFooter, PageNav},
  data() {
    return {
      isMenuOpen: false,
      memberList: [],
      richList: [],
      richList2: [],
    };
  },
  computed: {
    displayMemberList() {
      return [...(this.memberList || []), ...(this.memberList || [])];
    }
  },
  mounted() {
    this.getMemberList();
    this.getRichtextList();
    this.getRichtextList2();
  },
  methods: {
    goToSoft() {
      this.$router.push({
        name: 'Soft',
      })
    },
    goToCopyright() {
      this.$router.push({
        name: 'Copyright',
      })
    },
    goToTest() {
      this.$router.push({
        name: 'Test',
      })
    },
    goToEvaluate() {
      this.$router.push({
        name: 'Evaluate',
      })
    },
    goToDetail2(item) {
      this.$router.push({
        name: 'PolicyDetail',
        params: { id: item.id }
      })
    },
    goToDetail(item) {
      this.$router.push({
        name: 'NewsDetail',
        params: { id: item.id }
      })
    },
    getRichtextList() {
      getRichtextListApi({
        pageNum: 1,
        pageSize: 2,
        type: 2,
      }).then(res => {
        console.log('获取成功', res)
        this.richList = res.data.records;
      }).catch(err => {
        console.log('请求失败', err)
      })
    },
    getRichtextList2() {
      getRichtextListApi({
        pageNum: 1,
        pageSize: 5,
        type: 3,
      }).then(res => {
        console.log('获取成功', res)
        this.richList2 = res.data.records;
      }).catch(err => {
        console.log('请求失败', err)
      })
    },
    getMemberList() {
      getMemberListApi({
        pageNum: 1,
        pageSize: 6,
      }).then(res => {
        console.log('获取成功', res)
        this.memberList = res.data.records;
      }).catch(err => {
        console.log('请求失败', err)
      })
    },
    goToAbout() {
      this.$router.push('/about')
    },
    goToServices() {
      // this.$router.push('/services')
      // http://www.jss.org.cn/UserCenter/Login.aspx
      // window.location.href = 'http://www.jss.org.cn/UserCenter/Login.aspx';
      window.open('http://www.jss.org.cn/UserCenter/Login.aspx', '_blank');
    },
    goToStat() {
      this.$router.push('/services/stat')
    },
    goToMembers() {
      this.$router.push({
        name: 'Members',
      })
    },
    goToNews() {
      this.$router.push({
        name: 'News',
      })
    },
    goToPolicy() {
      this.$router.push({
        name: 'Policy',
      })
    },
    getMemberLogo(item) {
      const fileList = Array.isArray(item && item.fileList7) ? item.fileList7 : [];
      return fileList[0] && fileList[0].url ? fileList[0].url : require('@/assets/logo.jpg');
    },
    goTo(item) {
      this.$router.push({
        name: 'MemberDetail',
        params: { id: item.id }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.home-page {
  width: 100%;
  overflow: hidden;
}

.container {
  @include container;
}


/* banner */
.hero {
  height: 500px;
  position: relative;
}

.hero-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, $blue-900, transparent);
  display: flex;
  align-items: center;
  .container {
    max-width: 80rem;
    width: 100%;
  }
}

.hero-content {
  color: $white;

  h2 {
    font-size: 42px;
    margin-bottom: 20px;
    line-height: 1.2;
    text-align: center;
  }

  p {
    font-size: 16px;
    color: rgba(white, 1);
    margin-bottom: 30px;
    text-align: center;
  }
}

.btns {
  display: flex;
  gap: 70px;
  justify-content: center;
}

.btn-primary {
  background: $white;
  color: $blue-900;
  padding: 12px 30px;
  border-radius: 4px;
  font-weight: bold;
}

.btn-outline {
  border: 1px solid $white;
  color: $white;
  padding: 12px 30px;
  border-radius: 4px;
}
.service-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.service-item {
  background: #f8fafc; /* 默认浅灰背景 */
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  transition: all 0.3s ease;

  /* 默认状态 */
  .icon-box {
    width: 80px;
    height: 80px;
    background: #fff; /* 默认白色圆背景 */
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);

    iconify-icon {
      color: #1d4ed8; /* 默认蓝色图标 */
      display: block;
      transition: color 0.3s ease;
    }
  }

  span {
    font-size: 16px;
    color: #333; /* 默认深色文字 */
    transition: color 0.3s ease;
  }

  /* hover 状态（和你参考图完全一致） */
  &:hover {
    background: #1d4ed8; /* 背景变蓝 */
    color: #fff;

    .icon-box {
      background: rgba(255,255,255,0.3); /* 圆背景变浅蓝 */
      iconify-icon {
        color: #fff; /* 图标变白 */
      }
    }

    span {
      color: #fff; /* 文字变白 */
    }
  }
}

/* 新闻 */
/* ===================================== */
/* 行业资讯 + 政策法规（还原参考图） */
/* ===================================== */
.news-policy-section {
  padding: 60px 0;
  background: #f8fafc;
}
.grid-wrapper {
  display: flex;
  gap: 30px;
}
.news-left {
  flex: 2;
}
.policy-right {
  flex: 1;
}

/* 标题栏 */
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 12px;
  margin-bottom: 20px;
}
.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;

  iconify-icon {
    color: #1d4ed8;
  }
  .policy-icon {
    color: #dc2626;
  }
}
.more-btn {
  font-size: 14px;
  color: #64748b;
  transition: color 0.3s;

  &:hover {
    color: #1d4ed8;
  }
}

/* 新闻列表 */
.news-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.news-item {
  display: flex;
  gap: 16px;
  cursor: pointer;

  &:hover h4 {
    color: #1d4ed8;
  }
}
.pic {
  width: 140px;
  height: 100px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
}
.pic img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}
.news-item:hover .pic img {
  transform: scale(1.05);
}
.text-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.text-box h4 {
  font-size: 16px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 6px;
  transition: color 0.3s;
  line-height: 1.4;
  text-align: left;
}
.desc {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}
.date {
  font-size: 12px;
  color: #9ca3af;
  text-align: left;
}

/* 政策列表 */
.policy-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.policy-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;

  &:hover .text {
    color: #1d4ed8;
  }
}
.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #dc2626;
  margin-top: 8px;
  flex-shrink: 0;
}
.text {
  flex: 1;
  font-size: 14px;
  color: #334155;
  line-height: 1.6;
  transition: color 0.3s;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

/* 数据统计区块 - 与第二张截图1:1还原 */
.data-count {
  position: relative;
  padding: 70px 0;
  background-color: #0d2a74;
  overflow: hidden;
}

/* 背景图标 */
.data-icon {
  position: absolute;
  color: rgba(255, 255, 255, 0.1);
  z-index: 0;
  pointer-events: none;
}

/* 云朵：下移，和截图位置一致 */
.cloud {
  top: 15%;
  left: 2%;
  font-size: 220px;
}

/* 网络图标：位置微调 */
.network {
  bottom: -10%;
  right: 2%;
  font-size: 300px;
}

/* 数据容器：居中 */
.container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 数据网格：水平均匀分布 */
.data-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  text-align: center;
}

.data-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.data-item .num {
  font-size: 46px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 8px;
}

.data-item .label {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
}

.member-section {
  padding: 80px 0;
  background: #fff;
  text-align: center; /* 全局居中，所有子元素默认居中 */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 标题样式：文字和下划线都居中 */
.section-header {
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.section-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
}
.divider {
  width: 60px;
  height: 3px;
  background-color: #1d4ed8;
  margin: 0 auto; /* 下划线居中 */
}

/* Logo 轮播 */
.logo-carousel {
  position: relative;
  overflow: hidden;
  margin-bottom: 40px;
  padding: 8px 0;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    width: 80px;
    height: 100%;
    z-index: 1;
    pointer-events: none;
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  }
}

.logo-track {
  display: flex;
  width: max-content;
  gap: 20px;
  animation: logo-scroll 24s linear infinite;
  will-change: transform;
}

.logo-item {
  flex: 0 0 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #e2e8f0;
  height: 120px;
  padding: 10px;
  transition: box-shadow 0.3s ease;
}

.logo-item:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.logo-item img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}

@keyframes logo-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.view-all-link {
  color: #1d4ed8;
  font-size: 18px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.3s;
}
.view-all-link:hover {
  color: #1e40af;
}



/* 响应式 */
@media (max-width: 1024px) {
  .nav {
    display: none;
  }

  .mobile-btn {
    display: block;
  }

  .service-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .news-wrap {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .service-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .data-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 0;
  }

  .member-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

</style>
